<template>
  <div class="home">
    <div class="Header">
      <div id="left_menu">
        <div class="logo">
          <img src="/static/img/logo.png"/>
          <span>智达云服务平台</span>
        </div>
      </div>
      <img src="/static/img/height_light.png" alt="">
      <div class="header_nav">
        <router-link v-for="(item,index) in navNow" :key="index"
                     :to="item.route!=null?{name:item.route}:''" tag="a"><span>{{item.title}}</span></router-link>
      </div>
      <div class="userbox">
        <div>
          <img :src="userInfo.avatar"/>
          <!-- 图片地址动态绑定 -->
          <span>安平县路灯所</span>
          <a class="msg" :href="'http://'+'27.128.181.220:9998/management/News'"><span class="icon-msg"></span>
            <div v-if="this.tabledata!==0"><a>{{this.tabledata}}</a></div>
          </a>
          <button title="退出" @click="out"><span class="icon-out"></span>退出</button>
        </div>
      </div>
    </div>
    <div class="left_information">
      <div class="weather">
        <div>
          <div>
            <img v-if="weather_data[0].wea_img==='xue'" src="/static/img/weather/weather1.png" alt="雪">
            <img v-else-if="weather_data[0].wea_img==='lei'" src="/static/img/weather/weather2.png" alt="雷">
            <img v-else-if="weather_data[0].wea_img==='shachen'" src="/static/img/weather/weather3.png" alt="沙尘">
            <img v-else-if="weather_data[0].wea_img==='wu'" src="/static/img/weather/weather4.png" alt="雾">
            <img v-else-if="weather_data[0].wea_img==='bingbao'" src="/static/img/weather/weather5.png" alt="冰雹">
            <img v-else-if="weather_data[0].wea_img==='yun'" src="/static/img/weather/weather6.png" alt="多云">
            <img v-else-if="weather_data[0].wea_img==='yu'" src="/static/img/weather/weather7.png" alt="雨">
            <img v-else-if="weather_data[0].wea_img==='yin'" src="/static/img/weather/weather8.png" alt="阴">
            <img v-else-if="weather_data[0].wea_img==='qing'" src="/static/img/weather/weather9.png" alt="晴">
            <div>
              <h2>
                {{city}}
              </h2>
              <p>{{weather_data[0].wea}}</p>
              <p>{{weather_data[0].date}}</p>
            </div>
            <div>
              <h1>{{tem}}</h1>
              <p>{{weather_data[0].tem2}}&nbsp/&nbsp{{weather_data[0].tem1}}</p>
            </div>
          </div>
          <ul>
            <li  v-for="(item,index) in weather_data[0].hours" v-if="index<6">
              <p>{{hour[index]}}</p>
              <img v-if="item.wea==='小雪'||item.wea==='中雪'||item.wea==='大雪'||item.wea==='雨夹雪'" src="/static/img/weather/weather1.png" alt="雪">
              <img v-else-if="item.wea==='雷阵雨'" src="/static/img/weather/weather2.png" alt="雷阵雨">
              <img v-else-if="item.wea==='沙尘'" src="/static/img/weather/weather3.png" alt="沙尘">
              <img v-else-if="item.wea==='雾'" src="/static/img/weather/weather4.png" alt="雾">
              <img v-else-if="item.wea==='冰雹'" src="/static/img/weather/weather5.png" alt="冰雹">
              <img v-else-if="item.wea==='多云'" src="/static/img/weather/weather6.png" alt="多云">
              <img v-else-if="item.wea==='小雨'||item.wea==='中雨'||item.wea==='大雨'" src="/static/img/weather/weather7.png" alt="雨">
              <img v-else-if="item.wea==='阴'" src="/static/img/weather/weather8.png" alt="阴">
              <img v-else-if="item.wea==='晴'" src="/static/img/weather/weather9.png" alt="晴">
            </li>
          </ul>
        </div>
      </div>
      <div class="number">
        <h1>资源数量统计</h1>
        <ul>
          <li v-for="(item,index) in number">
            <div :style="[{background:'url('+number_img[index]+') no-repeat'},{'background-size':'100% 100%'}]"></div>
            <span>{{item.resource}}</span>
            <p>{{item.title}}</p>
          </li>
        </ul>
      </div>
      <div class="equipment">
        <h1>用电统计(设备)</h1>
        <div id="equipment"></div>
      </div>
      <div class="time">
        <h1>用电统计(时间)</h1>
        <div id="time"></div>
      </div>
    </div>
    <div style="color: white;position: absolute;left: 1115px;top: 392px;z-index:9999;font-size: 14px">{{this.lampstatisic.lamppost}}</div>
    <div id="homemap">
      <img src="/static/img/pointicon.png" style="position: absolute;left: 355px;top: 248px;z-index:1;" width="30" height="30">
      <img src="/static/img/homemap.png" width="700" height="672">
      <img src="/static/img/mapicon.png" style="position: relative;left: -347px;top: -90px;z-index: 9998" width="23" height="32">
    </div>
  </div>
</template>

<script>
  //引入echarts
  let echarts = require('echarts/lib/echarts');
  require('echarts/map/js/china');
  // 引入柱状图组件
  require('echarts/lib/chart/bar');
  require('echarts/lib/chart/line');
  require('echarts/lib/chart/map');
  require('echarts/lib/chart/scatter');
  require('echarts/lib/chart/effectScatter');
  // 引入提示框和title组件
  require('echarts/lib/component/tooltip');
  require('echarts/lib/component/title');
  require('echarts/lib/component/legend');
  require('echarts/lib/component/geo');
  require('echarts/lib/component/dataZoom');



  export default {
    computed: {
      user() {
        return this.$store.state.user
      }
    },

    name: "Home",
    data() {
      return {
        tem:'',
        tabledata:'',
        userInfo: {
          avatar: 'https://gss0.bdstatic.com/-4o3dSag_xI4khGkpoWK1HF6hhy/baike/c0%3Dbaike92%2C5%2C5%2C92%2C30/sign=62d46c39067b020818c437b303b099b6/d4628535e5dde7119c3d076aabefce1b9c1661ba.jpg'
        },
        navNow: [
          {
            title: "首页",
            route: "home"
          },
          {
            title: "GIS信息",
            route: "geographic_information"
          },
          {
            title: "远程监控",
            route: "monitoring"
          },
          // {
          //   title: "项目管理",
          //   route: "project_manage"
          // },
          {
            title: "运维管理",
            route: "management"
          },
          // {
          //   title: "资产管理",
          //   route: "management"
          // },
          {
            title: "系统管理",
            route: "Setting"
          },
        ],
        mapdata: [],
        weather_data: [
          {air: "", air_level: "", date: "", week: "", tem: "", wea: "", wea_img: "",hours:[{ day:"",wea:"",tem:"",win:"",win_speed:""}]},
          {day: "", tem1: "", tem2: "", wea_img: "", wea: ""},
          {day: "", tem1: "", tem2: "", wea_img: "", wea: ""},
          {day: "", tem1: "", tem2: "", wea_img: "", wea: ""},
          {day: "", tem1: "", tem2: "", wea_img: "", wea: ""},
          {day: "", tem1: "", tem2: "", wea_img: "", wea: ""},
          {day: "", tem1: "", tem2: "", wea_img: "", wea: ""},
        ],
        lampstatisic:'',

        number:[
          {title:"全部",resource:"32"},
          {title:"在线",resource:"24"},
          {title:"故障",resource:"8"},
        ],
        number_img:["/static/img/icon/home_circle1.png","/static/img/icon/home_circle2.png","/static/img/icon/home_circle3.png"],

        hour:['08时','11时','14时','17时','20时','23时'],
        city:'安平'
      }
    },
    methods: {
      out(){
        this.$router.push({path: '/'})
      },

      getOnStatic:function(){
        fetch("/api/v1/statistics", {
          method: 'post',
          body: JSON.stringify({
            project_id:"17e3b71e-b460-498e-b0ef-657d20bd6549"
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            this.lampstatisic = data.data;
            this.number[0].resource = data.data.wifi.total_count + data.data.alarm.total_count + data.data.camera.total_count + data.data.controller.total_count + data.data.led.total_count + data.data.sensor.total_count + data.data.sound.total_count;
            this.number[1].resource = data.data.wifi.online_count + data.data.alarm.online_count + data.data.camera.online_count + data.data.controller.online_count + data.data.led.online_count + data.data.sensor.online_count + data.data.sound.online_count;
            this.number[2].resource = data.data.wifi.fault_count + data.data.alarm.fault_count + data.data.camera.fault_count + data.data.controller.fault_count + data.data.led.fault_count + data.data.sensor.fault_count + data.data.sound.fault_count;
          })
      },

      parseDate: function () {
        var date = new Date();
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var hs = date.getHours();
        var minute = date.getMinutes();
        minute = minute < 10 ? ('0' + minute) : minute;
        var second= date.getSeconds();
        second = minute < 10 ? ('0' + second) : second;
        var h = parseInt(hs);
        if(8<=h&&h<11){
          this.tem = this.weather_data[0].hours[0].tem;
        }else if (11<=h&&h<14){
          this.tem = this.weather_data[0].hours[1].tem;
        }
        else if (14<=h&&h<17){
          this.tem = this.weather_data[0].hours[2].tem;
        }
        else if (17<=h&&h<20){
          this.tem = this.weather_data[0].hours[3].tem;
        }
        else if (20<=h&&h<23){
          this.tem = this.weather_data[0].hours[4].tem;
        }
        else if (0<=h&&h<2){
          this.tem = this.weather_data[0].hours[5].tem;
        }
        else if (2<=h&&h<5){
          this.tem = this.weather_data[0].hours[6].tem;
        }
        else if (5<=h&&h<8){
          this.tem = this.weather_data[0].hours[7].tem;
        }
      },


      init: function () {
        // 基于准备好的dom，初始化echarts实例
        var geoCoordMap = {
          '广州省': [113.5107, 23.2196],
          '北京市': [116.4551, 40.2539],
          '天津市': [117.4219, 39.4189],
          '上海市': [121.4648, 31.2891],
          '重庆市': [106.557165, 29.563206],
          '河北省': [114.508958, 38.066606],
          '河南省': [113.673367, 34.748062],
          '云南省': [102.721896, 25.047632],
          '辽宁省': [123.445621, 41.806698],
          '黑龙江省': [126.655705, 45.759581],
          '湖南省': [112.950888, 28.229114],
          '安徽省': [117.300842, 31.887672],
          '山东省': [117.029895, 36.677424],
          '新疆省': [87.616327, 43.800508],
          '江苏省': [118.814345, 32.061445],
          '浙江省': [120.16991, 30.272236],
          '江西省': [115.904962, 28.674132],
          '湖北省': [114.290138, 30.595623],
          '广西省': [108.381781, 22.815042],
          '甘肃省': [103.851217, 36.061978],
          '山西省': [112.57197, 37.879532],
          '内蒙古': [112.57197, 37.879532],
          '陕西省': [108.960062, 34.285251],
          '吉林省': [126.572746, 43.86785],
          '福建省': [119.319713, 26.072564],
          '贵州省': [106.557165, 29.563206],
          '广东省': [113.238778, 23.161621],
          '青海省': [101.787147, 36.621234],
          '西藏省': [91.154492, 29.665953],
          '四川省': [104.082256, 30.652565],
          '宁夏省': [106.234805, 38.487468],
          '海南省': [109.910757, 19.108187],
          '台湾': [121.098613, 23.778734],
          '香港': [114.168545, 22.36641],
          '澳门': [113.549978, 22.1943]
        }
        var data = this.mapdata
        var convertData = function (data) {
          var res = [];
          for (var i = 0; i < data.length; i++) {
            var geoCoord = geoCoordMap[data[i].name];
            if (geoCoord) {
              res.push({
                name: data[i].name,
                value: geoCoord.concat(data[i].value)
              });
            }
          }
          return res;
        };

        var colorArray = [
          {
            top: '#91e3f7', //黄
            bottom: '#468cff'
          }, {
            top: '#619dff', //绿
            bottom: '#326dce'
          },
          {
            top: '#aba0ff', //蓝
            bottom: '#7d6cff'
          }, {
            top: '#a0ffd3', //深蓝
            bottom: '#6cffa7'
          },
          {
            top: '#ffad56', //粉
            bottom: '#f7ffa0'
          },
        ];

        //let myChart1 = echarts.init(document.getElementById('map'));
        let myChart2 = echarts.init(document.getElementById('equipment'));
        let myChart3 = echarts.init(document.getElementById('time'));

        myChart2.setOption({
          tooltip: {
            show: true,
            formatter: "{b}:{c}(kw)"
          },
          grid: {
            left: '5%',
            top: '0%',
            right: '0%',
            bottom: '0px',
            containLabel: true
          },

          xAxis: {
            type: 'value',
            show:false,
          },
          yAxis: [{
            type: 'category',
            axisTick: {
              show: false,
              alignWithLabel: false,
              length: 5,

            },
            "splitLine": { //网格线
              "show": false
            },
            inverse: 'false', //排序
            axisLine: {
              show: false,
              lineStyle: {
                color: '#fff',
              }
            },
            data: ['智慧照明', '信息发布', '摄像头', '智能音箱', '无线WiFi']
          }

          ],
          series: [{
            name: '用电统计(设备)',
            type: 'bar',
            itemStyle: {
              normal: {
                show: true,
                color: function(params) {
                  let num = colorArray.length;
                  return {
                    type: 'linear',
                    colorStops: [{
                      offset: 0,
                      color: colorArray[params.dataIndex % num].bottom
                    }, {
                      offset: 1,
                      color: colorArray[params.dataIndex % num].top
                    }, {
                      offset: 0,
                      color: colorArray[params.dataIndex % num].bottom
                    }, {
                      offset: 1,
                      color: colorArray[params.dataIndex % num].top
                    }, {
                      offset: 0,
                      color: colorArray[params.dataIndex % num].bottom
                    }, {
                      offset: 1,
                      color: colorArray[params.dataIndex % num].top
                    }, {
                      offset: 0,
                      color: colorArray[params.dataIndex % num].bottom
                    }, {
                      offset: 1,
                      color: colorArray[params.dataIndex % num].top
                    }, {
                      offset: 0,
                      color: colorArray[params.dataIndex % num].bottom
                    }, {
                      offset: 1,
                      color: colorArray[params.dataIndex % num].top
                    }, {
                      offset: 0,
                      color: colorArray[params.dataIndex % num].bottom
                    }, {
                      offset: 1,
                      color: colorArray[params.dataIndex % num].top
                    }],
                    //globalCoord: false
                  }
                },
                barBorderRadius: 0,
                borderWidth: 0,
              }
            },
            barWidth:'10px',
            data: [426, 1413, 142, 26, 11]
          }
          ]
        });

        myChart3.setOption({
          tooltip: {
            trigger: 'axis',
            formatter: "{b}:{c}(kw)"
          },
          grid: {
            left: '2%',
            right: '2%',
            bottom: '3%',
            top:"20%",
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: '#c6cae5'
              }
            },
            data: ['9月','10月','11月']
          }],
          yAxis: [{
            type: 'value',
            name: '单位（kw）',
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#c6cae5'
              }
            },
            axisLabel: {
              margin: 5,
              textStyle: {
                fontSize: 14
              }
            },
            splitLine: {
              lineStyle: {
                type: 'solid',
                color: 'rgba(255,255,255,0.3)'
              }
            }
          }],
          series:{
            name: '用电统计(时间)',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 3
              }
            },
            areaStyle: {
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(0,253,252,0.8)'
                },
                  {
                    offset: 1,
                    color: 'rgba(0,150,239,0.8)'
                  }
                ], false),
                shadowColor: 'rgba(53,142,215, 0.9)', //阴影颜色
                shadowBlur: 10 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
              }
            },
            itemStyle: {
              normal: {
                color: "transparent"
              },
            },
            data: [445, 837, 745]
          }
        });
        window.onresize = function () {
          //myChart1.resize();
          myChart2.resize();
          myChart3.resize();
        };


      }
    },
    mounted() {
      //获取消息列表
      fetch("/api/v1/message/list", {
        method: 'post',
        body: JSON.stringify({
          "page_start": 0,
          "page_size": 10,
          "project_id": "17e3b71e-b460-498e-b0ef-657d20bd6549",
          "is_read": ""
        })
      })
        .then(result => {
          return result.json();//解析流
        })
        //.then(data => console.log(data))
        .then(data => {
          if (data.code == "200") {
            this.message = "消息列表获取成功";
            this.tabledata = data.unread_number;
          } else {
            this.message = "数据更新异常，请重试";
          }
        })
        .catch((error) => {
          this.message = "网络异常，请重试";
          this.msg_show = !this.msg_show;
        });

      this.getOnStatic();
      // this.$axios.get('/user-list').then( res => {
      //   this.mapdata = res;
      //   console.log(res);
      //   this.init();
      // }).catch(err => {
      //   console.log(err);
      // });
      // 获取天气
      this.$axios.get('/api/v1/common/weather?city=安平')
        .then(res => {
          console.log(res.data)//请求成功后的处理函数
          this.weather_data = res.data.data;
          this.parseDate();
          console.log(this.weather_data)
        }).catch(err => {                 //请求失败后的处理函数
        throw  err;
      })
      this.init();
    },
    // created() {
    //   this.$http.get("http://124.239.196.155/db_zdcloud_base/zd_user")
    //     .then((data) =>{
    //       console.log(data)
    //   })
    // }

  }
</script>

<style scoped>
  .home {
    background: url("/static/img/home_bg.jpg") no-repeat center center;
    background-size: 100% 100%;
  }
  .Header {
    width: 100%;
    height: 78px;
    background: -webkit-linear-gradient(left, #1d4e80, #0c365f); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(right, #1d4e80, #0c365f); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(right, #1d4e80, #0c365f); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, #1d4e80, #0c365f); /* 标准的语法 */
    position: relative;
  }
  .Header > img {
    position: absolute;
    bottom: -8px;
    left: 0;
  }
  .Header > p {
    width: 460px;
    padding-left: 80px;
    text-align: left;
    float: left;
    color: #FFFFFF;
    font-size: 24px;
    line-height: 78px;
    position: relative;
    box-sizing: border-box;
  }
  .header_nav {
    width: auto;
    display: flex;
    align-items: center;
    float: left;
    height: 78px;
  }
  .header_nav a {
    width: 126px;
    line-height: 78px;
    height: 78px;
    text-align: center;
    position: relative;
    left: 320px;
    text-decoration: none;
  }
  .header_nav a span {
    /*color: #FFFFFF;*/
    font-family: "方正正中黑简体";
    background-image: -webkit-linear-gradient(bottom, #169cff, #2bffff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 20px;
    font-weight: bold;
  }
  .header_nav .checked {
    background: #02386c;
  }
  .header_nav .checked:before {
    width: 106px;
    position: absolute;
    top: 0;
    left: 0;
    height: 2px;
    background: #00f0ff;

    content: '';
    z-index: 10;
  }
  .header_nav .checked span {
    -webkit-text-stroke-width: 0px;
    background-image: -webkit-linear-gradient(bottom, #ffffff, #ffffff);
  }
  .userbox {
    height: 78px;
    width: auto;
    float: right
  }

  .userbox div {
    width: auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .userbox div img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: 8px
  }

  .userbox > div > span {
    color: #95bee5;
    margin-right: 20px
  }

  .userbox .msg {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: 20px;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .userbox .msg span {
    font-size: 20px;
    color: #ffffff
  }

  .userbox .msg div {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    position: absolute;
    top: -6px;
    right: -6px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ff0000;
  }

  .userbox .msg div a {
    color: #ffffff;
    font-size: 10px;
    -webkit-transform: scale(0.8);
  }

  .userbox button {
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    outline: none;
    background: transparent;
    margin-right: 20px;
    font-size: 16px;
    height: 22px;
    line-height: 22px;
    color: #95bee5;
    cursor: pointer;
  }
  .userbox button span {
    margin-right: 4px
  }
  .left_information {
    position: absolute;
    width: 350px;
    height: calc(100% - 78px);
    padding: 0 30px 20px;
    box-sizing: border-box;
    top: 78px;
    left: 0;
    background: rgba(18, 63, 109, 0.4);
  }
  .left_information > div {
    width: 100%;
    height: 25%;
    box-sizing: border-box;
    border-bottom: 1px solid #2d4f89;
  }
  .left_information > div:last-child {
    border-bottom: none;
  }
  #homemap {
    position: absolute;
    left: 750px;
    top: 160px;
    height: calc(100% - 160px);
    width: calc(100% - 760px);
  }
  .weather>div{
    width: 100%;
    height: 100%;
    padding-top: 20px;
    box-sizing: border-box;
  }
  .weather>div>div:nth-child(1){
    height: 90px;
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
  }
  .weather>div>div:nth-child(1)>img{
    max-width: 50px;
    margin-right: 30px;
  }
  .weather>div>div:nth-child(1)>div:nth-child(2){
    height: 100px;
    width: auto;
  }
  .weather>div>div:nth-child(1)>div:nth-child(2)>p{
    color: #FFFFFF;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    margin-bottom: 0;
  }
  .weather>div>div:nth-child(1)>div:nth-child(2)>h2{
    font-size: 20px;
    height: 60px;
    line-height: 60px;
    color: #FFFFFF;
    margin-bottom: 0;
  }
  .weather>div>div:nth-child(1)>div:nth-child(3){
    position: absolute;
    right: 0;
    top: 0;
  }
  .weather>div>div:nth-child(1)>div:nth-child(3)>h1{
    height: 60px;
    line-height: 60px;
    font-size: 48px;
    color: #FFFFFF;
    margin-bottom: 0;
  }
  .weather>div>div:nth-child(1)>div:nth-child(3)>p{
    color: #FFFFFF;
    margin-bottom: 0;
    text-align: right;
  }
  .weather>div>ul{
    height: 90px;
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
  }
  .weather>div>ul>li{
    width: 16.6%;
    height: 100%;
  }
  .weather>div>ul>li>p{
    margin: 10px 0px;
    height: 20px;
    text-align: center;
    color: #FFFFFF;
    font-size: 14px;
  }
  .weather>div>ul>li>img{
    max-width: 60%;
    max-height: 40px;
    display: block;
    margin: 0 auto;
  }
  .number>h1{
    font-size: 16px;
    height: 40px;
    line-height: 50px;
    color: #FFFFFF;
  }
  .number>ul{
    display: flex;
    width: 100%;
    height: calc(100% - 50px);
  }
  .number>ul>li{
    width: 33.33%;
    height: 100%;
    position: relative;
  }
  .number>ul>li>div{
    width: 87px;
    height: 87px;
    margin: 5px auto;
    animation: mymove 5s infinite linear;
  }
  @keyframes mymove{
    0%{
      transform:rotate(0deg);                /*w3c标准*/
      -webkit-transform:rotate(0deg);   /*webkit内核的safari和chrome*/
      -moz-transform:rotate(0deg);      /*ff*/
      -o-transform:rotate(0deg);          /*opera*/
      -ms-transform:rotate(0deg);  /*IE9*/
    }
    100%{
      transform:rotate(360deg);                /*w3c标准*/
      -webkit-transform:rotate(360deg);   /*webkit内核的safari和chrome*/
      -moz-transform:rotate(360deg);      /*ff*/
      -o-transform:rotate(360deg);          /*opera*/
      -ms-transform:rotate(360deg);  /*IE9*/
    }
  }
  .number>ul>li>span{
    display: block;
    color: #FFFFFF;
    margin-top: 2px;
    position: absolute;
    width: 20%;
    text-align: center;
    top: 35px;
    left: 40%;
  }
  .number>ul>li>p{
    color: #FFFFFF;
    text-align: center;
    margin-top: 20px;
  }
  .equipment>h1,.time>h1{
    font-size: 16px;
    height: 40px;
    line-height: 50px;
    color: #FFFFFF;
  }
  #equipment,#time{
    width: 100%;
    height: calc(100% - 50px);
    color: transparent;
  }

  #left_menu {
    width: 350px;
    height: 78px;
    position: absolute;
    left: 0;
    top: 0;
    background: #1d4e80
  }

  #left_menu .logo {
    width: 100%;
    height: 78px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #left_menu .logo img {
    margin-right: 10px;
  }

  #left_menu .logo span {
    font-size: 22px;
    color: #ffffff;
    font-weight: bold;
  }

</style>



// WEBPACK FOOTER //
// src/components/Home.vue